import { useMemo, useState } from "react";
import { AreaChartProps } from "@arelia-components/ui-atoms/AreaChart";
import { StreamingInterval } from "@arelia-types/streaming";
import StreamingChartPresenter from "./StreamingChartPresenter";
import { ConnectionName } from "@arelia-types/connection";
import useRequiredConnections from "@arelia-utils/helpers/useRequiredConnections";
import { useChartListeners } from "../../api/streaming";
import { useChartDataArtistFilter } from "@arelia-hooks/artistAccount";
import { formatDate } from "@arelia-utils/helpers/dates";

export default function ListenersContainer() {
  const [period, setPeriod] = useState(StreamingInterval.daily);
  const requiredConnectionNames = [ConnectionName.youtube, ConnectionName.spotify, ConnectionName.amazon, ConnectionName.appleMusic, ConnectionName.pandora];
  const hasRequiredConnections = useRequiredConnections(requiredConnectionNames);

  const { data, isLoading, isError } = useChartListeners(period, { enabled: hasRequiredConnections });
  const filteredData = useChartDataArtistFilter(data);

  const chartListeners = useMemo(
    () => {
      if (!filteredData) return { labels: [], data: [], datasets: [] };
      const dateFormat = period !== StreamingInterval.monthly ? 'LLL dd' : 'LLL yyyy';
      return filteredData.reduce((res: AreaChartProps, curr, i) => {
        if (i === 0) res.labels = curr.labels.map(l => formatDate(l, dateFormat));
        res.data.push(curr.data);
        res.datasets.push(curr.networkName);
        return res;
      }, { labels: [], data: [], datasets: [] })
    },
    [filteredData]
  );

  return <StreamingChartPresenter
    widgetId='LISTENERS'
    title='Listeners'
    chartListeners={chartListeners}
    loading={isLoading}
    error={isError}
    period={period}
    unconnected={!hasRequiredConnections}
    setPeriod={setPeriod}
  />;
}
